import * as React from "react";
import {IReduxState} from "reducers";
import {connect} from "react-redux";
import {Link} from "react-router-dom";
import Modal from "components/Modal";
import ShubhForm from "shubhform";
import {getRegisterUserFields, profileStyle, RegisterUserField} from "egold/utils";
import {registerUser} from "egold/actions";
import {vendor} from "egold/egold-config";
import {sliceValueUptoMaxLength, validateName, validatePhoneNumber} from "userform/utils";
import {indexPath, routePaths} from "egold/routes";

interface IConnectProps {
    dispatch?: (action: any) => void;
    emailId: string;
    userId: number;
}
interface IProps {
    active: boolean;
    handleClose?: () => void;
}
type finalProps = IConnectProps & IProps;
function RegisterUser(props: finalProps) {
    function handleRegisterUser(currentValues) {
        const userInfo = {};
        currentValues.forEach((field) => {
            userInfo[field.name] = field.value;
        });
        props.dispatch(registerUser(vendor.SAFEGOLD, userInfo, props.userId));
    }
    return(
        <div>
            <Modal
                title={"Enter the details"}
                active={props.active}
                cancellable={true}
                onClose={props.handleClose}
                disableFooter={true}
            >
                <div className="px-2 my-4">
                    <ShubhForm
                        fields={getRegisterUserFields(props.emailId)}
                        onSubmit={handleRegisterUser}
                        onValidate={handleValidation}
                        customStyles={profileStyle()}
                        onChangeHook={onChangeHook}
                        submitTitle="Submit"
                    />
                    <div className="text-center mt-3" style={{fontSize: "13px"}}>
                        By continuing you agree to the
                        <Link to = {`${indexPath}${routePaths.TERMS_AND_CONDITIONS}`}><b> Terms & Conditions</b></Link>
                    </div>
                </div>
            </Modal>
        </div>
    );
}
function handleValidation(currentValues) {
    let validation = {status: true, errors: null};
    for (const i of currentValues) {
        i.value = String(i.value).trim();
        if (i.value === "") {
            validation = {status: false, errors: {[i.name]: "Field is required"}};
            break;
        } else if (i.name === RegisterUserField.MOBILE && !validatePhoneNumber(i.value)) {
            validation = {status: false, errors: {[i.name]: "Invalid Number"}};
            break;
        } else if (i.name === RegisterUserField.NAME && !validateName(i.value)) {
            validation = {status: false, errors: {[i.name]: "Invalid Name"}};
            break;
        } else if (i.name === RegisterUserField.PIN && i.value.length !== 6) {
            validation = {status: false, errors: {[i.name]: "Invalid Pincode"}};
            break;
        }
    }
    return validation;
}
function onChangeHook(fieldDetails) {
    if (fieldDetails.name.includes("mobile")) {
        fieldDetails.value = sliceValueUptoMaxLength(fieldDetails.value, 10);
    } else if (fieldDetails.name.includes("pin")) {
        fieldDetails.value = sliceValueUptoMaxLength(fieldDetails.value, 6);
    }
    return fieldDetails;
}
const mapStateToProps = (state: IReduxState): IConnectProps => {
    return {
        emailId: state.login.auth.email,
        userId: state.login.auth.userId,
    };
};

export default connect<IConnectProps, {}, {}>(mapStateToProps)(RegisterUser);
